
import { RBAClient } from 'rba-client'
const moment = require('moment')
const client = RBAClient.getInstance(require('@/api/config'))

const state = {
  search: '',
  orderby: '',
  order: '',
  page: 0,
  limit: 10,
  loading: false,

  individualRecords: [],
  corporateRecords: [],

  blacklistDetails: {
    id: null,
    WATCHLIST_ID: '',
    FIRST_NAME: '',
    LAST_NAME: '',
    NAME: '',
    GENDER: '',
    COUNTRY: '',
    ISO2: '',
    DATE_OF_BIRTH: '',
    DATE_OF_INCORPORATION: '',
    is_deleted: false,
    create_date: null,
    updated_date: null
  },

  listing: {
    requestTimeout: null,
    requestLoading: false,
    columns: [
      'WATCHLIST_ID',
      'FIRST_NAME',
      'LAST_NAME',
      'NAME',
      'GENDER',
      'COUNTRY',
      'ISO2',
      'DATE_OF_BIRTH',
      'DATE_OF_INCORPORATION',
      'create_date',
      'actions'
    ],
    dateColumns: ['create_date'],
    options: {
      initFilters: [],
      initialPage: 1,
      perPage: 10,
      orderBy: {
        ascending: true,
        column: null
      },
      requestFunction (request) {
        console.log('requestFunction')
        console.log(request)
        this.requestKeys = request
        clearTimeout(this.requestTimeout)
        return new Promise((resolve, reject) => {
          this.requestTimeout = setTimeout(async () => {
            try {
              var criteria = {
                where: (((query) => {
                  var _where = { and: [] }

                  if (query.WATCHLIST_ID) _where.WATCHLIST_ID = { $Contains: query.WATCHLIST_ID }
                  if (query.FIRST_NAME) _where.FIRST_NAME = { $Contains: query.FIRST_NAME }
                  if (query.LAST_NAME) _where.LAST_NAME = { $Contains: query.LAST_NAME }
                  if (query.NAME) _where.NAME = { $Contains: query.NAME }
                  if (query.COUNTRY) _where.COUNTRY = query.COUNTRY
                  if (query.ISO2) _where.ISO2 = query.ISO2

                  if (query.create_date) {
                    _where.and = [
                      ..._where.and,
                      { create_date: { '>': moment(query.create_date.start).valueOf() } },
                      { create_date: { '<': moment(query.create_date.end).valueOf() } }
                    ]
                  }

                  return _where
                })(request.query)),
                limit: request.limit,
                skip: request.limit * (request.page - 1),
                sort: request.orderBy ? `${request.orderBy} ${request.ascending ? 'ASC' : 'DESC'}` : 'create_date DESC'
              }

              // Promise.all([
              //   client.blacklist.count(criteria),
              //   client.blacklist.findWhere(criteria)
              // ])
              //   .then(([{ data: { count } }, { data }]) => {
              //     resolve({ data, count })
              //   })
              //   .catch((error) => {
              //     reject(error)
              //   })
            } catch (error) {
              reject(error)
            }
          }, 1500)
        })
      },
      columnsClasses: {
        WATCHLIST_ID: 'col-xs-2',
        FIRST_NAME: 'col-xs-2',
        LAST_NAME: 'col-xs-2',
        NAME: 'col-xs-3',
        GENDER: 'col-xs-1',
        COUNTRY: 'col-xs-2',
        ISO2: 'col-xs-1',
        DATE_OF_BIRTH: 'col-xs-2',
        DATE_OF_INCORPORATION: 'col-xs-2',
        create_date: 'col-xs-2',
        actions: 'col-xs-1'
      },
      sortable: [
        'WATCHLIST_ID',
        'FIRST_NAME',
        'LAST_NAME',
        'NAME',
        'COUNTRY',
        'create_date'
      ],
      filterable: [
        'WATCHLIST_ID',
        'FIRST_NAME',
        'LAST_NAME',
        'NAME',
        'COUNTRY',
        'ISO2',
        'create_date'
      ],
      filterByColumn: true,
      dateColumns: ['create_date']
    }
  }
}

// getters
const getters = {
  loading: state => {
    return state.loading
  },
  blacklistDetails: state => {
    return state.blacklistDetails
  },
  individualRecords: state => {
    return state.individualRecords
  },
  corporateRecords: state => {
    return state.corporateRecords
  },
  listing_options: (state, getters, rootState, { i18n }) => {
    const { initFilters, initialPage, perPage, orderBy, requestFunction, columnsClasses, sortable, filterable, filterByColumn, dateColumns } = state.listing.options

    return {
      initFilters,
      initialPage,
      perPage,
      orderBy,
      requestFunction,
      columnsClasses,
      sortable,
      headings: {
        WATCHLIST_ID: i18n.t('screen.blacklist.table.watchlist_id.label'),
        FIRST_NAME: i18n.t('screen.blacklist.table.first_name.label'),
        LAST_NAME: i18n.t('screen.blacklist.table.last_name.label'),
        NAME: i18n.t('screen.blacklist.table.name.label'),
        GENDER: i18n.t('screen.blacklist.table.gender.label'),
        COUNTRY: i18n.t('screen.blacklist.table.country.label'),
        ISO2: i18n.t('screen.blacklist.table.iso2.label'),
        DATE_OF_BIRTH: i18n.t('screen.blacklist.table.date_of_birth.label'),
        DATE_OF_INCORPORATION: i18n.t('screen.blacklist.table.date_of_incorporation.label'),
        create_date: i18n.t('screen.blacklist.table.create_date.label'),
        actions: i18n.t('screen.blacklist.table.action.label')
      },
      filterable,
      filterByColumn,
      dateColumns,
      texts: {
        count: i18n.t('listing.table.texts.count'),
        first: i18n.t('listing.table.texts.first'),
        last: i18n.t('listing.table.texts.last'),
        filter: i18n.t('listing.table.texts.filter'),
        filterPlaceholder: i18n.t('listing.table.texts.filterPlaceholder'),
        limit: i18n.t('listing.table.texts.limit'),
        page: i18n.t('listing.table.texts.page'),
        noResults: i18n.t('listing.table.texts.noResults'),
        noRequest: i18n.t('listing.table.texts.noRequest'),
        filterBy: i18n.t('listing.table.texts.filterBy'),
        loading: i18n.t('listing.table.texts.loading'),
        defaultOption: i18n.t('listing.table.texts.defaultOption'),
        columns: i18n.t('listing.table.texts.columns')
      }
    }
  }
}

// actions
const actions = {
  fetchIndividualRecords ({ commit }) {
    return client.blacklist.getIndividual()
      .then(r => {
        console.log('fetchIndividualRecords')
        console.log(r)
        const results = r.data
        if (results.code === 200 && results.data && results.data.records) {
          commit('SET_INDIVIDUAL_RECORDS', results.data.records)
        }
        return results
      })
  },
  postIndividualRecords (_, data) {
    return client.blacklist.postIndividual(data)
      .then(r => {
        console.log('postIndividualRecords')
        console.log(r)
        const results = r.data
        return results
      })
  },
  putIndividualRecord (_, data) {
    return client.blacklist.putIndividual(data)
      .then(r => {
        console.log('putIndividualRecord')
        console.log(r)
        const results = r.data
        return results
      })
  },
  deleteIndividualRecord (_, watchlistId) {
    return client.blacklist.deleteIndividual(watchlistId)
      .then(r => {
        console.log('deleteIndividualRecord')
        console.log(r)
        const results = r.data
        return results
      })
  },

  fetchCorporateRecords ({ commit }) {
    return client.blacklist.getCorporate()
      .then(r => {
        console.log('fetchCorporateRecords')
        console.log(r)
        const results = r.data
        if (results.code === 200 && results.data && results.data.records.length > 0) {
          commit('SET_CORPORATE_RECORDS', results.data.records)
        }
        return results
      })
  },
  postCorporateRecords (_, data) {
    console.log('postCorporateRecords')
    console.log(data)
    return client.blacklist.postCorporate(data)
      .then(r => {
        console.log('postCorporateRecords')
        console.log(r)
        const results = r.data
        return results
      })
  },
  putCorporateRecord (_, data) {
    return client.blacklist.putCorporate(data)
      .then(r => {
        console.log('putCorporateRecord')
        console.log(r)
        const results = r.data
        return results
      })
  },
  deleteCorporateRecord (_, watchlistId) {
    return client.blacklist.deleteCorporate(watchlistId)
      .then(r => {
        console.log('deleteCorporateRecord')
        console.log(r)
        const results = r.data
        return results
      })
  }
}

// mutations
const mutations = {
  SET_LOADING: (state, payload) => {
    state.loading = payload
  },
  SET_INDIVIDUAL_RECORDS: (state, records) => {
    state.individualRecords = [...records]
  },
  SET_CORPORATE_RECORDS: (state, records) => {
    state.corporateRecords = [...records]
  },
  'blacklistTable/LOADING' (state, payload) {
    state.listing.options.initFilters = payload.query
    if (state.listing.options.initFilters.create_date) {
      state.listing.options.initFilters.create_date.start = moment(state.listing.options.initFilters.create_date.start)
      state.listing.options.initFilters.create_date.end = moment(state.listing.options.initFilters.create_date.end)
    }
    state.listing.options.initialPage = payload.page
    state.listing.options.perPage = payload.limit
    state.listing.options.orderBy.ascending = payload.ascending
    state.listing.options.orderBy.column = payload.orderBy
    state.listing.requestLoading = true
  },
  'blacklistTable/LOADED' (state, data) {
    state.listing.requestLoading = false
  },
  'blacklistTable/ERROR' (state, data) {
    state.listing.requestLoading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
